module.exports = __webpack_public_path__ + "img/ic_nav_music-on-active.1e52a2bd.svg";